import React from 'react'

import Icon from '../../Shared/Icon'

// Re-use the styling that already exists for the settings sidebar
import '../../Settings/Settings.scss'

const SettingsSidebar = ({ activeTab, onTabChange }) => {
  // Put "Apps" first since Dashboard shows apps screen by default
  const links = [
    { id: 'apps', label: 'Apps', icon: 'list-round' },
    { id: 'account', label: 'Account', icon: 'account-circle' },
    { id: 'team', label: 'Team Members', icon: 'users' },
    { id: 'billing', label: 'Usage & Billing', icon: 'credit-card' },
    { id: 'domains', label: 'Domains', icon: 'link' },
    { id: 'ai', label: 'AI Assistant', icon: 'ada', comingSoon: true },
  ]

  return (
    <div className="settings-page-sidebar dashboard-settings-sidebar">
      {links.map(({ id, label, icon, comingSoon }) => (
        <div
          key={id}
          className={`settings-page-tab settings-page-tab-${id} ${
            activeTab === id ? 'active' : ''
          } ${comingSoon ? 'coming-soon' : ''}`}
          data-adalo-id={`dashboard-settings-tab-${id}`}
          onClick={comingSoon ? undefined : () => onTabChange(id)}
        >
          <Icon type={icon} />
          {label}
          {comingSoon && <span className="coming-soon-badge">COMING SOON</span>}
        </div>
      ))}
    </div>
  )
}

export default SettingsSidebar
